import styled, { css } from 'styled-components';
import { PropertyContainer } from '~/components/ui/PropertyContainer';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	width: 380px;
	margin-top: 30px;
`;

const StyledPresetsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 50px;
	column-gap: 10px;
`;

const StyledSectionBody = styled.div<{ $locked?: boolean }>`
	position: relative;
	margin-top: 20px;

	${({ $locked }) =>
		$locked &&
		css`
			height: 302px;
			overflow: hidden;
		`}

	> ${PropertyContainer} {
		position: relative;
		z-index: 0;
	}
`;

const StyledSettingsCategoryHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledSettingsCategoryName = styled.div`
	display: flex;
	align-items: center;
	column-gap: 10px;

	img {
		opacity: 0.75;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		color: #ffffff;
		opacity: 0.75;
		font-size: 16px;
		font-weight: 400;
	}
`;

const StyledResetButton = styled.button.attrs({
	tabIndex: -1,
})`
	width: 65px;
	height: 20px;
	border-radius: 6px;
	background-color: rgba(255, 255, 255, 0.1);
	color: #fff;
	font-family: GT Walsheim Pro;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	border: none;
	cursor: pointer;
	user-select: none;

	transition: all 0.3s ease;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}
`;

const StyledSettingsContainer = styled.div`
	height: 473px;
	overflow-y: scroll;
	width: 380px;
	margin-top: 30px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledPopupContainer = styled.div`
	position: absolute;
	//top: 50px;
	right: -85px;
	z-index: 6;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 40px;
	padding: 0 10px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.9);
	opacity: 0;
	transition: opacity 0.3s ease;

	${Text} {
		color: #000000;
		font-size: 14px;
		font-weight: 400;
	}

	&.popup-enter {
		opacity: 0;
	}

	&.popup-enter-active,
	&.popup-enter-done,
	&.popup-exit {
		opacity: 1;
	}

	&.popup-exit-active {
		opacity: 0;
	}
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
	margin-top: 30px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	img {
		width: 14px;
		height: 14px;
	}
`;

export {
	StyledButtonContent,
	StyledButtonsContainer,
	StyledContainer,
	StyledPopupContainer,
	StyledPresetsContainer,
	StyledResetButton,
	StyledSectionBody,
	StyledSettingsCategoryHead,
	StyledSettingsCategoryName,
	StyledSettingsContainer,
};
